// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
}
.container p-togglebutton {
  border-radius: 0;
}
.container p-togglebutton:first-child {
  border-top-left-radius: var(--p-togglebutton-border-radius);
  border-bottom-left-radius: var(--p-togglebutton-border-radius);
}
.container p-togglebutton:last-child {
  border-top-right-radius: var(--p-togglebutton-border-radius);
  border-bottom-right-radius: var(--p-togglebutton-border-radius);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ngx-components/lib/wrappers/components/bitbutton/bitbutton.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,gBAAA;AACJ;AACE;EACE,2DAAA;EACA,8DAAA;AACJ;AACE;EACE,4DAAA;EACA,+DAAA;AACJ","sourcesContent":[".container\n  display: flex\n\n  p-togglebutton\n    border-radius: 0\n\n  p-togglebutton:first-child\n    border-top-left-radius: var(--p-togglebutton-border-radius)\n    border-bottom-left-radius: var(--p-togglebutton-border-radius)\n\n  p-togglebutton:last-child\n    border-top-right-radius: var(--p-togglebutton-border-radius)\n    border-bottom-right-radius: var(--p-togglebutton-border-radius)\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
